import styles from './CouponModal.module.scss';
import leftArrow from '../../assets/leftArrow02.png';
import { useEffect, useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { ICouponType } from '../../pages/Order/Order';
import { useTranslation } from 'react-i18next';

interface IPropsType {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  couponList: ICouponType[];
  useCoupon: ICouponType | undefined;
  setUseCoupon: React.Dispatch<React.SetStateAction<ICouponType | undefined>>;
}
function CouponModal(props: IPropsType) {
  const [selectedCoupon, setSelectedCoupon] = useState<ICouponType>();
  useEffect(() => {
    setSelectedCoupon(props.useCoupon);
  }, []);
  function handleSubmit() {
    props.setUseCoupon(selectedCoupon);
    props.setOpen(false);
  }
  const { t, i18n } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.contentWrap}>
        <h3 className={styles.header}>
          <img
            src={leftArrow}
            alt="leftArrow"
            onClick={() => props.setOpen(false)}
          />
          <span>{t('order.21')}</span>
        </h3>
        <div className={styles.couponListWrap}>
          <div className={styles.useableCouponWrap}>
            <span>
              {t('order.22')}
              <span>
                {
                  props.couponList.filter((coupon) => coupon.status == 'N')
                    .length
                }
              </span>
              sheets
            </span>
            <ul className={styles.useableCouponList}>
              {props.couponList
                .filter((coupon) => coupon.status == 'N')
                .map((coupon) => (
                  <li
                    key={coupon.id}
                    onClick={() => {
                      if (coupon.id !== selectedCoupon?.id)
                        setSelectedCoupon(coupon);
                      else setSelectedCoupon(undefined);
                    }}
                  >
                    <div
                      className={`${styles.coupon} ${
                        selectedCoupon?.id == coupon.id ? styles.hit : ''
                      }`}
                    >
                      <div className={styles.customCheckbox}></div>
                      <span>{coupon.coupon_name}</span>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <div className={styles.unuseableCouponWrap}>
            <span>
              {t('order.23')}
              <span>
                {
                  props.couponList.filter((coupon) => coupon.status == 'E')
                    .length
                }
              </span>
              sheets
            </span>
            <ul className={styles.unuseableCouponList}>
              {props.couponList
                .filter((coupon) => coupon.status == 'E')
                .map((coupon) => (
                  <li key={coupon.id}>
                    <div className={styles.coupon}>
                      <div className={styles.customCheckbox}></div>
                      <span>{coupon.coupon_name}</span>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className={styles.couponGuideWrap}>
          <h4>{t('order.24')}</h4>
          <ul>
            <li>· {t('order.25')}</li>
            <li>· {t('order.26')}</li>
            <li>· {t('order.27')}</li>
            <li>· {t('order.28')}</li>
            <li>· {t('order.29')}</li>
          </ul>
        </div>

        <div className={styles.submitBtn} onClick={handleSubmit}>
          {t('order.18')}
        </div>
      </div>
    </div>
  );
}
export default CouponModal;
